import 'oidc-token-manager/dist/oidc-token-manager';
import 'core-js/es6';
import 'reflect-metadata';
import 'zone.js/dist/zone';
import 'zone.js/dist/long-stack-trace-zone';


/** WEBPACK FOOTER **
 ** ./app/polyfills.ts
 **/